import { render, staticRenderFns } from "./CompanySummary.vue?vue&type=template&id=1f4ff1e6&"
import script from "./CompanySummary.vue?vue&type=script&lang=js&"
export * from "./CompanySummary.vue?vue&type=script&lang=js&"
import style0 from "./CompanySummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports